import React from 'react';
import Tab from '@mui/material/Tab';
import { Link } from 'react-router-dom';

interface MarketTabProps {
    label?: string;
    to: string;
    value: string;
    selected?: boolean;
}

function TradeTab(props: MarketTabProps) {
    return <Tab component={Link} {...props} disableRipple />
}

export default TradeTab;